import { render, staticRenderFns } from "./AdminPrintReceipt.vue?vue&type=template&id=52eef1ed"
import script from "./AdminPrintReceipt.vue?vue&type=script&lang=js"
export * from "./AdminPrintReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports